import { render, staticRenderFns } from "./OccurranceExpPanelv2.vue?vue&type=template&id=0a35ef86&scoped=true&"
import script from "./OccurranceExpPanelv2.vue?vue&type=script&lang=js&"
export * from "./OccurranceExpPanelv2.vue?vue&type=script&lang=js&"
import style0 from "./OccurranceExpPanelv2.vue?vue&type=style&index=0&id=0a35ef86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35ef86",
  null
  
)

export default component.exports